var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscYellowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.5H14V22.5H22V14.5ZM6.5 2.5L11 10.5H2L6.5 2.5ZM18 10.5C19.0609 10.5 20.0783 10.0786 20.8284 9.32843C21.5786 8.57828 22 7.56087 22 6.5C22 5.43913 21.5786 4.42172 20.8284 3.67157C20.0783 2.92143 19.0609 2.5 18 2.5C16.9391 2.5 15.9217 2.92143 15.1716 3.67157C14.4214 4.42172 14 5.43913 14 6.5C14 7.56087 14.4214 8.57828 15.1716 9.32843C15.9217 10.0786 16.9391 10.5 18 10.5Z",
    fill: "url(#paint0_linear_25_3495)",
    stroke: "#FED525",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5L10 22.5L2 14.5ZM10 14.5L2 22.5L10 14.5Z",
    fill: "url(#paint1_linear_25_3495)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5L10 22.5M10 14.5L2 22.5",
    stroke: "#FED525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_3495",
    x1: 31.8286,
    y1: 31.306,
    x2: 2.61769,
    y2: 30.4151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_3495",
    x1: 13.9314,
    y1: 26.0224,
    x2: 2.24708,
    y2: 25.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC305"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscYellowIcon);
export default __webpack_public_path__ + "static/media/subsc_yellow-icon.6e1ed0960c15a5813beae8017d77e9c9.svg";
export { ForwardRef as ReactComponent };